export function deepCopy(source: Object) {
  return JSON.parse(JSON.stringify(source));
}
